import React from "react";
import { Icons, Text } from "@evvve/ui-kit";

import Link from "src/shared-features/Link";

import styles from "./style.module.scss";
import NotificationTemplate from "../NotificationTemplate";
import { TheEventStartsIn3HoursMessage } from "../../../types";

const TheEventStartsIn3Hours = ({ message }: { message: TheEventStartsIn3HoursMessage }) => {
  const { eventId, eventTitle } = message;

  return (
    <NotificationTemplate>
      <div className={styles.info}>
        <Icons.Info color="tangerine1000" size="s" />
        <Text size="m" color="tangerine1000">
          The event start in 3 hours
        </Text>
      </div>
      <Link color="violet" to={`/catalog/event/${eventId}`}>
        {eventTitle}
      </Link>
    </NotificationTemplate>);
};

export default TheEventStartsIn3Hours;
